<template>
  <div class="extensions">
    <Submenu
      v-if="routes && !show_routes.includes($route.name)"
      :routes="routes"
      :key="`${l.detect()}${$route.name}`"
    />
    <ExtensionsFragment
      v-if="$route.name === 'extensions.index'"
      data-test-id="extensions-index"
    />
    <ExtensionsCreateFragment
      v-if="$route.name === 'extensions.create'"
      data-test-id="extensions-create"
    />
    <ExtensionsShowFragment
      v-if="show_routes.includes($route.name)"
      data-test-id="extensions-show"
    />
  </div>
</template>

<script>
import l from '../../../libs/lang';
import ExtensionsFragment from './index.vue';
import ExtensionsShowFragment from './show.vue';
import Submenu from '../../elements/Submenu.vue';
import ExtensionsCreateFragment from './create.vue';

export default {
  components: {
    Submenu,
    ExtensionsFragment,
    ExtensionsCreateFragment,
    ExtensionsShowFragment,
  },
  data() {
    // const show_routes = {
    //   'extensions.show': { title: l.t('app.settings', 'Settings')},
    //   'extensions.visualize': { title: l.t('app.visualizer', 'Visualizer')},
    //   'extensions.call-flow': { title: l.t('call-handling.call-handling', 'Call Handling')},
    //   'extensions.type': { title: l.t('app.type', 'Type')},
    // };
    const show_routes = [
      'extensions.show',
      'extensions.visualize',
      'extensions.call-flow',
      'extensions.type',
    ];
    const routes = {
      'extensions.index': {
        title: l.t('app.extensions', 'Extensions')
        },
      'extensions.visualizer': {
        title: l.t('app.visualizer', 'Visualizer')
        },
      'extensions.create': {
        title: l.t('app.add-extension', 'Add extension')
        },
    };
    // if (Object.keys(show_routes).includes(this.$route.name)) {
    //   routes = {...show_routes};
    // }
    return {
      l,
      show_routes,
      routes,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (window.deleting_in_progress) {
      this.$emit('userRedirected', to, from, next);
    } else {
      next();
    }
  },
};
</script>
